var LoaderVariants;
(function (LoaderVariants) {
    LoaderVariants["Local"] = "local";
    LoaderVariants["Global"] = "global";
})(LoaderVariants || (LoaderVariants = {}));

export { LoaderVariants };
